export const EMAIL_PROFILE_WIDGET_QA_NAME_AI_SUMMARY = 'aiSummary'

export const EMAIL_PROFILE_WIDGET_QA_NAME_LABELS = 'labels'

export const EMAIL_PROFILE_WIDGET_COPIED_TO_LIST_TYPE = {
  buildings: 'buildings',
  contractors: 'contractors',
  external_contacts: 'external_contacts',
  flats: 'flats',
  inhabitants: 'inhabitants',
  staff_members: 'staff_members',
}
